var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-form-field"},[_c('label',{staticClass:"cms-label"},[_vm._t("label")],2),_vm._v(" "),_c('input',_vm._g(_vm._b({attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners)),_vm._v(" "),_c('span',{staticClass:"cms-field-hint"},[_vm._t("hint")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44a8a879","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/cms/Input.vue
// module id = Km4Z
// module chunks = 0 1